import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AppProviders from "./context";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <Router>
    <AppProviders>
      <App />
    </AppProviders>
  </Router>,

  document.getElementById("root")
);

serviceWorker.unregister();
